import React, { useState, useEffect } from 'react';

const WithdrawForm = ({
  email,
  expectedWithdrawal,
  earnings,
  wallet,
  BreakPayout,
  investedAmount,
  totalToWithdraw,
  error,
  fetchingEarnings,
  isSubmitDisabled,
  loading,
  showBreakInvestmentButton,
  onSubmitNormal,  // Callback function for normal form submission
  onSubmitModal  // Callback function for modal form submission
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [showBreakInvestmentModal, setShowBreakInvestmentModal] = useState(false); // Local state to control the button visibility

  // Handle modal toggle
  const handleModalToggle = () => {
    setIsModalOpen(!isModalOpen);
  };

  // Normal form submission
  const handleNormalSubmit = async (e) => {
    e.preventDefault();
    onSubmitNormal(email, wallet, totalToWithdraw);  // Pass the normal form data to the parent
  };

  // Modal form submission
  const handleModalSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitting modal form:", email, wallet, BreakPayout); // Log the values
    onSubmitModal(email, wallet, BreakPayout);  // Pass modal form data to the parent
    setIsModalOpen(false); // Close modal after submission
  };

  // Watch for changes in isSubmitDisabled and update showBreakInvestmentModal accordingly
  useEffect(() => {
    if (isSubmitDisabled) {
      setShowBreakInvestmentModal(true);  // Show the break investment button when submit is disabled
    } else {
      setShowBreakInvestmentModal(false);  // Hide the break investment button when submit is enabled
    }
  }, [isSubmitDisabled]);

  return (
    <div className="withdraw-form-container">
      {/* Normal Form */}
      <form onSubmit={handleNormalSubmit} className="form-container">
        <div className="input-group">
          <input type="hidden" value={email} readOnly />
        </div>

        <div className="input-group">
          <label>Expected Withdrawal Balance:</label>
          <input type="number" value={expectedWithdrawal} required readOnly />
        </div>

        <div className="input-group">
          <label>Earnings:</label>
          {fetchingEarnings ? (
            <p>Loading earnings...</p>
          ) : (
            <input type="text" value={earnings} id="earnings" name="earnings" readOnly />
          )}
          <p className="total-info"> Earnings from referring others, Note this can't be 0 </p>
        </div>

        <div className="input-group">
          <label>Your USDT Bep20 Wallet on file is:</label>
          <input type="text" value={wallet} id="wallet" name="wallet" placeholder="Contact support to change wallet" readOnly />
        </div>

        {error && <p className="error-text">{error}</p>}
        <p className="total-info"> Your total Withdrawable after handling fees today is ${totalToWithdraw}</p>

        <div className="input-group">
          <input type="hidden" value={totalToWithdraw} id="total" name="total" readOnly />
        </div>

        <div className="submit-button">
          <button type="submit" disabled={isSubmitDisabled || loading}>
            {loading ? 'Processing...' : 'Submit'}
          </button>
        </div>

        {/* Conditionally render the "Break Investment" button */}
        {showBreakInvestmentModal && (
          <div className="break-investment-btn-container">
            <button type="button" className="break-investment-btn" onClick={handleModalToggle}>
              Break Investment
            </button>
          </div>
        )}
      </form>

      {/* Modal for breaking investment */}
      {isModalOpen && (
        <div className="modal">
          <div className="modal-content">
            <span className="close" onClick={handleModalToggle}>&times;</span>
            <h2 className="modal-title">Break Investment</h2>
            <form onSubmit={handleModalSubmit}>
              <div className="input-group">
                <p className="total-info"> You Invested ${investedAmount}, you will get 40% back if you decide to go ahead</p>
                <input type="hidden" value={email} id="email" name="email" readOnly /> 
              </div>
              <div className="input-group">
                <label>Your USDT Bep20 Wallet on file is:</label>
                <input type="text" value={wallet} id="wallet" name="wallet" readOnly /> 
              </div>
              <div className="input-group">
                <label>Total:</label>
                <input type="number" value={BreakPayout} id="total" name="total" readOnly /> 
                <p className="total-info">Your final refund after handling Fees</p>
              </div>
              <div className="submit-button">
                <button type="submit">Submit</button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Styling */}
      <style>{`
        /* Add your styles here */
        .withdraw-form-container {
          padding: 20px;
        }
        .input-group {
          margin-bottom: 15px;
        }

        label {
          font-weight: bold;
        }

        input {
          width: 100%;
          padding: 8px;
          margin-top: 5px;
          margin-bottom: 10px;
          font-size: 16px;
        }

        .submit-button button {
          background-color: #4CAF50;
          color: white;
          border: none;
          padding: 10px 20px;
          font-size: 16px;
          cursor: pointer;
        }

        .submit-button button:disabled {
          background-color: #ccc;
          cursor: not-allowed;
        }

        .break-investment-btn-container {
          margin-top: 20px;
        }

        .break-investment-btn {
          background-color: #f44336;
          color: white;
          padding: 10px 20px;
          font-size: 16px;
          cursor: pointer;
        }

        .break-investment-btn:hover {
          background-color: #d32f2f;
        }

        /* Modal Styles */
        .modal {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background-color: rgba(0, 0, 0, 0.5);
          display: flex;
          justify-content: center;
          align-items: center;
          z-index: 1000;
        }

        .modal-content {
          background-color: white;
          padding: 20px;
          border-radius: 10px;
          width: 300px;
          text-align: center;
        }

        .close {
          position: absolute;
          top: 10px;
          right: 10px;
          font-size: 24px;
          cursor: pointer;
        }

        .modal-title {
          font-size: 20px;
          margin-bottom: 10px;
        }

        .input-group {
          margin-bottom: 10px;
        }

        .input-group input {
          width: 100%;
        }

        .modal .submit-button button {
          background-color: #4CAF50;
          color: white;
        }
      `}</style>
    </div>
  );
};

export default WithdrawForm;
